<script lang="ts" setup>
import {ReccoRecommendationTypeDTO} from '@/ts/types/dto/recco/recommendation.dto';
import type {ReccoArticleDTO} from '@/ts/types/dto/recco/article.dto';
import ReccoContentCard from '@/vue/molecules/recco/recommendation-cards/recommendation-card-content.vue';

const props = defineProps<{
  articleRecommendation: ReccoArticleDTO;
}>();

const {articleRecommendation} = props;
</script>

<template>
  <div class="article-container">
    <recco-content-card :recommendation="{...articleRecommendation, type: ReccoRecommendationTypeDTO.Article}"/>

    <div class="article-text-container">
      <p v-if="articleRecommendation.lead" class="article-lead">
        {{ articleRecommendation.lead }}
      </p>

      <div v-safe-html="articleRecommendation.articleBodyHtml" class="article-body"/> <!--eslint-disable-line vue/no-v-html-->
    </div>
  </div>
</template>

<style lang="scss" scoped>
.article-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-spacing-4);
  padding-bottom: var(--Spacing-spacing-5);
  border-radius: var(--card-border-radius);
  // Match the audio/video cards' full container width so all content types share
  // the same dimensions; without this the card shrinks to its content when the
  // poster has no intrinsic width (e.g. a not-yet-loaded image) (IPD-2893).
  width: 100%;
}

.article-text-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: var(--Spacing-spacing-7) var(--Spacing-spacing-8) var(--Spacing-spacing-8) var(--Spacing-spacing-6);
  gap: var(--Spacing-spacing-4);
  flex-shrink: 0;

  @include screen-2xl {
    @include column-width(6, 10);
  }

  @include screen-xl {
    @include column-width(9, 10);
  }

  @include screen-lg {
    @include column-width(8, 10);
  }

  @include screen-md {
    @include column-width(8, 10);
  }
}

.article-lead {
  @include font-h3-bold;
  margin-bottom: 0;
}

.article-body {
  :deep(ul) {
    padding-left: 20px;
    margin-bottom: var(--Spacing-spacing-6);
  }

  :deep(li) {
    word-break: normal;
  }

  :deep(p) {
    @include font-body;
  }
}
</style>
